export function numberFromCommaOnly(raw) {
  let s = (raw || '')
    .trim()
    .replace(/\s+/g, '')
    .replace(/[^\d,.-]/g, '');

  const last = s.lastIndexOf(',');
  if (last !== -1) {
    const dec = s.slice(last + 1);
    if (/^\d{1,2}$/.test(dec)) {
      // coma decimal
      return Number(s.slice(0, last).replace(/,/g, '') + '.' + dec);
    }
  }
  return Number(s.replace(/,/g, ''));
}

export function observeConvertedPrice({ containerSelector, priceSelector, onChange }) {
  const container = document.querySelector(containerSelector);
  if (!container) return { disconnect() {} };

  let lastText = null;
  let rafId = null;

  const readAndNotify = () => {
    const priceEl = container.querySelector(priceSelector);
    if (!priceEl) return;
    const txt = (priceEl.textContent || '').trim();
    if (txt && txt !== lastText) {
      lastText = txt;
      onChange(txt, priceEl);
    }
  };

  const observer = new MutationObserver(() => {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(readAndNotify);
  });

  observer.observe(container, {
    subtree: true,
    childList: true,
    characterData: true,
  });
  readAndNotify();
  return { disconnect: () => observer.disconnect() };
}